import React, {useState,useEffect,useContext} from "react";
import Modal from "react-bootstrap/Modal";

import Lang from '../../lang/translations';
import Context from '../../context/context';
import helpersFunction from '../../_helpers/helpersFunction';


export default function SceltaCanaleNotifiche(props) {

    const [regioni, setRegioni] = useState({});


  
    const  context = useContext(Context)


       const handleChoice = (method) => {
        console.log(`Utente ha scelto: ${method}`);
        // Qui puoi aggiungere la logica per salvare la scelta
      };


        useEffect(() => { 
          
 
        },[]);


    return ( <> <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="popuphook"
      >
        <Modal.Body>
         <div className="notification_popup_metodo">
              <h2 className="title">Non perderti messaggi e like</h2>
              <p className="subtitle">
                Se non vuoi ricevere email, puoi scegliere Telegram: è discreto, istantaneo e puoi disattivarlo quando vuoi. 
              </p>
              <p className="sub_subtitle">
                Aggiorna il canale con cui preferisci 
                restare aggiornato in tempo reale.
              </p>

              <div className="options">
                <button
                  className="option-button"
                  onClick={() => handleChoice("email")}
                >
                  <div className="icon email-icon" />
                  <span>Email</span>
                </button>

                <button
                  className="option-button"
                  onClick={() => handleChoice("telegram")}
                >
                  <div className="icon telegram-icon" />
                  <span>Telegram</span>
                </button>


                
              </div>

              <p className="note">
                <u>Non voglio ricevere aggiornamenti</u>
              </p>
              
          </div>
        </Modal.Body>
      </Modal></>);

}